import { render, staticRenderFns } from "./CalendarHolidayLegend.vue?vue&type=template&id=9eb8085c&scoped=true&"
import script from "./CalendarHolidayLegend.vue?vue&type=script&lang=js&"
export * from "./CalendarHolidayLegend.vue?vue&type=script&lang=js&"
import style0 from "./CalendarHolidayLegend.vue?vue&type=style&index=0&id=9eb8085c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb8085c",
  null
  
)

export default component.exports